import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classnames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { s as styles, C as ChipContent } from './ChipContent-Bv5BKf_5.js';
import '@hh.ru/magritte-ui-typography';

const STYLE_TO_CSS = {
    neutral: styles.chipStyleNeutral,
    accent: styles.chipStyleAccent,
};
const CheckableChipComponent = ({ style = 'neutral', type = 'checkbox', addon, postfix, hideLabel, children, disabled, 'aria-label': ariaLabel, dataQaWrapper = 'chip', size = 'medium', mode = 'primary', ...inputProps }, ref) => {
    const forceDisabled = useDisabled();
    const isComponentDisabled = disabled || forceDisabled;
    return (jsxs("label", { className: classnames(styles.chip, STYLE_TO_CSS[style], {
            [styles.sizeSmall]: size === 'small',
            [styles.chipSecondary]: mode === 'secondary',
        }), ref: ref, "data-qa": dataQaWrapper, "data-interactive": true, children: [jsx("input", { ...inputProps, type: type, className: styles.input, disabled: isComponentDisabled }), jsx(ChipContent, { size: size, postfix: postfix, addon: addon, "aria-label": ariaLabel, hideLabel: hideLabel, mode: mode, children: children })] }));
};
const CheckableChip = forwardRef(CheckableChipComponent);

export { CheckableChip };
//# sourceMappingURL=CheckableChip.js.map
